<!-- App.vue -->
<template>
  <div id="app">
    <div class="mobile-container">
      <main class="app-main">
        <router-view v-slot="{ Component }">
          <keep-alive include="MainView,HomeView">
            <component :is="Component" />
          </keep-alive>
        </router-view>
      </main>
    </div>
  </div>
</template>
<script setup>
import { ref, provide } from 'vue'
const showCodeModal = ref(false)
const currentAssessmentType = ref('')

// 提供给子组件触发兑换码弹窗的方法
const showCodeModalForType = (type) => {
  currentAssessmentType.value = type
  showCodeModal.value = true
}

provide('showCodeModal', showCodeModalForType)
</script>

<style>
/* 全局样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}

html, body {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  /* background: linear-gradient(135deg, #667eea 0%, #764ba2 50%); */
  background: white;
  overscroll-behavior: none;
}

#app {
  width: 100%;
  height: 100%;
  position: relative;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* 移动端容器 */
.mobile-container {
  max-width: 100%;
  min-height: 100vh;
  margin: 0 auto;
  position: relative;
  /* background: linear-gradient(135deg, #667eea 0%, #764ba2 50%); */
  background: white
}

/* 顶部标签栏 */
.app-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
  height: 60px;
  padding: 0 20px;
}

.tab-container {
  display: flex;
  height: 100%;
  max-width: 500px;
  margin: 0 auto;
}

.tab {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #999;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.tab .icon {
  font-size: 20px;
  margin-bottom: 4px;
  transition: all 0.3s ease;
}

.tab span {
  font-size: 12px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.tab.active {
  color: #ff9900;
}

.tab.active .icon {
  transform: translateY(-2px);
}

.tab.active span {
  font-weight: 600;
}

.tab.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 40px;
  height: 3px;
  background: #ff9900;
  border-radius: 2px;
}

/* 主要内容区域 */
.app-main {
  /* padding-top: 60px; */
  padding-bottom: env(safe-area-inset-bottom, 20px);
  /* min-height: calc(100vh - 60px); */
  overflow-x: hidden;
  height: 100vh;
}

/* 动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* 滚动条样式 */
::-webkit-scrollbar {
  width: 4px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}

/* 防止移动端点击延迟 */
* {
  touch-action: manipulation;
}

/* 长按不出现菜单 */
* {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}

input,
textarea,
select {
  -webkit-touch-callout: default !important;
  -webkit-user-select: auto !important;
  user-select: auto !important;
}
</style>